export default class Event {
  id: string;

  type: string;

  createdDate: Date;

  context: string;

  events?: Event[];

  constructor(obj: any) {
    this.id = obj.id || '';
    this.type = obj.type || '';
    this.createdDate = obj.createdDate || '';
    this.context = obj.context || '';
    if (obj.events) {
      this.events = obj.events.map(Event.of);
    }
  }

  public static of(value: any): Event {
    return new Event(value || {});
  }

  public static ofList(response: any): Event[] {
    return response.data.map(this.of);
  }
}
